import { render, staticRenderFns } from "./ZCcunliangzichanfenlei.vue?vue&type=template&id=2937a8d2&scoped=true"
import script from "./ZCcunliangzichanfenlei.vue?vue&type=script&lang=js"
export * from "./ZCcunliangzichanfenlei.vue?vue&type=script&lang=js"
import style0 from "./ZCcunliangzichanfenlei.vue?vue&type=style&index=0&id=2937a8d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2937a8d2",
  null
  
)

export default component.exports